import {
  memo,
  Suspense,
  useEffect,
  useState,
  useCallback,
  useMemo,
  lazy,
} from 'react'
import clsx from 'clsx'
import {
  ExpandMore as ExpandMoreIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
} from '@material-ui/icons/'
import useRouter from 'src/hooks/useRouter'
import { Link } from 'react-router-dom'

import CustomButton from 'src/components/CustomButton'
import styles from './styles.module.scss'

const ProvidingItem = lazy(() => import('./ProvidingItem'))

const Item = ({ value, onMobileClose }) => {
  const { pathname } = useRouter()
  const [isSelected, setIsSelected] = useState()
  const thereIsSubItems = useMemo(() => value?.items?.length, [
    value?.items?.length,
  ])
  const isActive = useMemo(
    () =>
      thereIsSubItems ? pathname.includes(value.href) : pathname === value.href,
    [pathname, value.href, thereIsSubItems]
  )

  const openTab = useCallback(
    (page) => () => {
      if (page === 'Груз от курьера (МОБ)') onMobileClose()
      if (!thereIsSubItems) return
      setIsSelected((prevVal) =>
        !prevVal && thereIsSubItems && isActive ? true : false
      )
    },
    [thereIsSubItems, onMobileClose, isActive]
  )

  useEffect(() => {
    thereIsSubItems && openTab()
  }, [thereIsSubItems, openTab])

  return (
    <div className={styles.container}>
      <Suspense fallback={<></>}>
        <Link key={value.href} to={value.href}>
          <CustomButton
            className={styles.content}
            onClick={openTab(value.title)}>
            <div>
              <span className={clsx(styles.title, isActive && styles.active)}>
                {value.title}
              </span>
              {value.titleEN && (
                <span className={clsx(styles.title, styles.titleEN)}>
                  {value.titleEN}
                </span>
              )}
            </div>
            {thereIsSubItems ? (
              isSelected ? (
                <ExpandMoreIcon />
              ) : (
                <KeyboardArrowRightIcon />
              )
            ) : (
              <></>
            )}
          </CustomButton>
        </Link>
        {isSelected && thereIsSubItems && <ProvidingItem value={value} />}
      </Suspense>
    </div>
  )
}

export default memo(Item)
